import {
  CSSProperties,
  Center,
  Group,
  type MantineSize,
  Table,
  Text,
  UnstyledButton,
  useMantineTheme,
} from '@mantine/core'
import { IconChevronDown, IconChevronUp, IconSelector } from '@tabler/icons-react'
import cx from 'classnames'

import styles from './LXTable.module.scss'

type LXThProps = {
  children: React.ReactNode
  sortDir?: 'asc' | 'desc'
  sorted?: boolean
  justify?: CSSProperties['justifyContent']
  size?: MantineSize
  onSort?(): void
}

export const LXTh = ({ children, sortDir, sorted, onSort, justify, size }: LXThProps) => {
  const Icon = sorted ? (sortDir === 'asc' ? IconChevronUp : IconChevronDown) : IconSelector
  const theme = useMantineTheme()

  if (typeof sorted === 'undefined' && typeof sortDir === 'undefined') {
    return (
      <Table.Th className={cx(styles.th, size ? styles[size] : undefined)}>
        <Group className={styles.controlNoAction} justify={justify}>
          <Group justify="space-between">
            <Text fw={700} size="sm">
              {children}
            </Text>
          </Group>
        </Group>
      </Table.Th>
    )
  }

  return (
    <Table.Th className={cx(styles.thSorted, size ? styles[size] : undefined)}>
      <UnstyledButton onClick={onSort} className={styles.control} w={80}>
        <Group justify={justify ?? 'apart'} wrap="nowrap">
          <Text fw={700} size="sm" c={sorted ? theme.colors.blue[7] : undefined}>
            {children}
          </Text>
          <Center className={styles.icon}>
            <Icon
              size={14}
              stroke={sorted ? 3 : 1.5}
              color={sorted ? theme.colors.blue[7] : undefined}
            />
          </Center>
        </Group>
      </UnstyledButton>
    </Table.Th>
  )
}
